import { defineStore } from "pinia"
import { computed, ref, type Ref } from "vue"
import { type IInstructionFilter } from "@/interfaces/component/instruction-filter.interface"

export const usePlanningStore = defineStore("planningStore", () => {
  const serviceProviderContainerFilters: Ref<Record<string, IInstructionFilter>> = ref({})
  const selectSequentalDaysOnNextLoad: Ref<boolean> = ref(true)

  const serviceProviderContainerFiltersArray = computed(() => {
    return Object.entries(serviceProviderContainerFilters.value)
      .map(([id, filter]) => ({
        id: Number(id),
        ...filter
      }))
      .sort((a, b) => a.id - b.id)
  })

  // Keep track of the current filter ID to ensure unique IDs for each filter
  let currentFilterId = 0

  function registerFilter(filter: IInstructionFilter) {
    currentFilterId++
    serviceProviderContainerFilters.value[currentFilterId] = filter
    return currentFilterId
  }

  function unregisterFilter(filterId: number) {
    delete serviceProviderContainerFilters.value[filterId]
  }

  function getLastInstructionColumnDate() {
    if (serviceProviderContainerFiltersArray.value.length > 0) {
      const lastFilter =
        serviceProviderContainerFiltersArray.value[
          serviceProviderContainerFiltersArray.value.length - 1
        ]
      return lastFilter.selectedMoment
    }
    return null
  }

  return {
    serviceProviderContainerFiltersArray,
    selectSequentalDaysOnNextLoad,
    getLastInstructionColumnDate,
    registerFilter,
    unregisterFilter
  }
})
